import Vue from 'vue'
import Vuex from 'vuex'
import {getByKeyword, getByRating, getByVorstieg, getByToprope, getByContest, getByNew, getByGrade } from './filters.js'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isSidebar: false,
    isFilter: '2',
    isNavigate: true,
    isQRcode: false,
    previewSector: false,
    fromMap: false,
    isMapbox: true,
    tenduLoading: true,

    isNumber: '1',
    isBack: true,

    sectorLink: '',
    pageTitle: 'Loading...',
    sectorQuery: '',

    sectorDetails: [],
    sectorStats: [],
    sectorSeries: [{
      name: 'series',
      data: []
    }],
    totalSeries: [{
      name: 'series',
      data: []
    }],
    onsightSeries: [{
      name: 'series',
      data: []
    }],
    flashSeries: [{
      name: 'series',
      data: []
    }],
    redpointSeries: [{
      name: 'series',
      data: []
    }],

    globalDataSeries: [0,0,0,0,0,0,0],
    globalCategories: ["3","4","5","6","7","8","9"],

    byRating: 0,
    byVorstieg: false,
    byToprope: false,
    byMinorGrade: 2,
    byMajorGrade: 36,
    byGrade: [1,36],
    byNew: false,
    byContest: false,
    byKeyword:'',
    isResetKiosk: false,
    updateKiosk: true,
    markOpen: false,
    rateOpen: false,
    keyFilter:0,

    storeList: [],
    listTemp: [],
    changeSector: '',
    filterSet: 'C',
    routeStatements: [],
    attributes: '',
    isTag: false,

    sortOptions: [
      {
        name: 'Nach Datum',
        note: 'Neue Routen zuerst',
        icon: 'view_list',
        iconset: false,
        query: '?order=sortweight'
      },
      {
        name: 'Nach Beliebtheit',
        note: '',
        icon: 'star',
        iconset: false,
        query: '?order=popularity'
      },
      {
        name: 'Nach Schwierigkeit',
        note: 'schwere Routen zuerst',
        icon: 'fitness_center',
        iconset: false,
        query: '?order=hard_first'
      },
      {
        name: 'Nach Schwierigkeit',
        note: 'leichte Routen zuerst',
        icon: 'static/leaf-solid.svg',
        iconset: true,
        query: '?order=easy_first'
      },
      {
        name: 'Nach Alphabet',
        note: '',
        icon: 'sort_by_alpha',
        iconset: false,
        query: '?order=name'
      },
    ],

    isRating: false,
    userRating: 0,
    slideRange: '',
    publicComment: '',
    userAttributes: [],

    pageLoading: true,
    isListLoading: false,
    projectLoading: false,
    statsLoading: false,

    defaultMinor: 8,
    defaultMajor: 29,

    active: [{
      links: [{
        ratingStatement: ''
      }]
    }
    ],
    popValue: 0,
    popCount:0,

    marker: [480, 160],
    gymMarker: [480, 160],
    xCoord: 480,
    yCoord: 160,
    isLocated: false,
    draggable: true,

    gymListDetails: [],
    numberSector: 0,
    gymTitle: '',
    sectorGymId: null,
    routeGymId: null,
    defaultSector: '',
    gymAdmin: [],

    gymWalls: [],
    gymClimbo: {
      routeName: '',
      gradeNo: '',
      gradeFrench: '',
      remarks: '',
      grade: '',
      color: '',
      attributes: [],
      routeSetter: '',
      routeRemovedBy: '',
      internalNote: '',
      dateCreated: '',
      wallArea: '',
      isLead: '',
      isToprope: '',
      overview: '',
      editUrl: '',
      sortWeight: '',
      isPublished: '',
      editUrl: '',
      links: []
    },

    gymActive: {
      routeName: '',
      gradeNo: '',
      remarks: '',
      grade: '',
      gradeFrench: '',
      color: '',
      attributes: [],
      routeSetter: '',
      routeRemovedBy: '',
      internalNote: '',
      dateCreated: '',
      wallArea: '',
      isLead: '',
      editUrl: '',
      unpublishable: '',
      isToprope: '',
      overview: '',
      isPublished: '',
      links: []
    },
    fromGymList: false,
    isActiveName: '',

    qrPrintLink: '',
    signLink: '',
    excelLink: '',
    importLink: '',
    updateSort: '',

    newRouteLink: '',
    url: '',
    urlGym: '',
    logDate: null,

    climboTab: '1',
    projectTrash: false,
    profileEdit: false,
    imagePreview: '',

    noOfLoading: 50,
    activeOnly: true,
    nextLink: '',
    prevLink: '',
    pagStar: 0,
    pagLimit: 0,
    totalGymRoutes: 0,

    validUser: {
      hash: '',
      value: ''
    },
    profileMail: '',
    userPrivileges: [],
    isSetter: false,
    isManager: false,

    totalKPI: [],
    onsightKPI: [],
    flashKPI: [],
    redpointKPI: [],

    timePeriod: 'all',
    cutOffDate: null,

    projectRoutes: [],
    projectsId: [-1],

    signup: '',
    confirmation: 'confirmation',
    token:'',

    sectorColors: [],

    routeColors: [
      {
        name: 'Blau',
        color: 'blue'
      },
      {
        name: 'Blau-Orange',
        color: 'blueOrange'
      },
      {
        name: 'Braun',
        color: 'brown'
      },
      {
        name: 'Brombeer',
        color: 'rebeccaPurple'
      },
      {
        name: 'Gelb',
        color: 'gold'
      },
      {
        name: 'Grau',
        color: 'grey'
      },
      {
        name: 'Grün',
        color: 'green'
      },
      {
        name: 'Hellblau',
        color: 'lightSkyBlue'
      },
      {
        name: 'Lila',
        color: 'purple'
      },
      {
        name: 'Meliert',
        color: 'mixed'
      },
      {
        name: 'Neon Gelb',
        color: 'yellow'
      },

      {
        name: 'Neon Grün',
        color: 'lime'
      },
      {
        name: 'Neon Pink',
        color: 'fuchsia'
      },

      {
        name: 'Neon Orange',
        color: 'darkOrange'
      },

      {
        name: 'Orange',
        color: 'orange'
      },

      {
        name: 'Pink',
        color: 'pink'
      },
      {
        name: 'Rot',
        color: 'red'
      },
      {
        name: 'Sand',
        color: 'oldLace'
      },
      {
        name: 'Schwarz',
        color: 'black'
      },
      {
        name: 'Schwarz-Gelb',
        color: 'blackYellow'
      },
      {
        name: 'Struktur',
        color: 'structure'
      },
      {
        name: 'Türkis',
        color: 'darkTurquoise'
      },
      {
        name: 'Weiß',
        color: 'white'
      },
      {
        name: 'Weiß-Lila',
        color: 'whitePurple'
      },
      {
        name: 'Weiß-Pink',
        color: 'whitePink'
      },
      {
        name: 'Weiß-Rot',
        color: 'whiteRed',
      },
      {
        name: 'Weiß-Türkis',
        color: 'whiteDarkTurquoise'
      }
    ],

    frenchValues: [
      { value: '1-', french: '1' },
      { value: '1', french: '1' },
      { value: '1+', french: '1' },
      { value: '2-', french: '2' },
      { value: '2', french: '2' },
      { value: '2+', french: '2' },
      { value: '3-', french: '3' },
      { value: '3', french: '3' },
      { value: '3+', french: '3' },
      { value: '4-', french: '4' },
      { value: '4', french: '4' },
      { value: '4+', french: '4b' },
      { value: '5-', french: '5a' },
      { value: '5', french: '5a' },
      { value: '5+', french: '5b' },
      { value: '6-', french: '5b' },
      { value: '6', french: '5c' },
      { value: '6+', french: '6a' },
      { value: '7-', french: '6a+' },
      { value: '7', french: '6b' },
      { value: '7+', french: '6b+' },
      { value: '8-', french: '6c+' },
      { value: '8', french: '7a' },
      { value: '8+', french: '7a+' },
      { value: '9-', french: '7b+' },
      { value: '9', french: '7c' },
      { value: '9+', french: '7c+' },
      { value: '10-', french: '8a+' },
      { value: '10', french: '8b' },
      { value: '10+', french: '8b+' },
      { value: '11-', french: '8c' },
      { value: '11', french: '9a' },
      { value: '11+', french: '9a+' },
      { value: '12-', french: '9b+' },
      { value: '12', french: '9c' },
    ],

    promoVideos: [
      { id: 'promo1',
        url: '../static/banner_one.mp4',
        big: '../static/banner_one.mp4',
        thumb: '../static/banner_one.mp4',
      },
      { id: 'promo2',
        url: '../static/banner_two.mp4',
        big: '../static/banner_two.mp4',
        thumb: '../static/banner_two.mp4',
      }
    ],

    promoPhotos: [
      { id: 'promo1',
        url: '../static/tenduAdd_D.jpg',
        big: '../static/tenduAdd_D.jpg',
        thumb: '../static/tenduAdd_D.jpg',
      },
      { id: 'promo2',
        url: '../static/tenduAdd_E.jpg',
        big: '../static/tenduAdd_E.jpg',
        thumb: '../static/tenduAdd_E.jpg',
      },
      { id: 'promo3',
        url: '../static/tenduAdd_F.jpg',
        big: '../static/tenduAdd_F.jpg',
        thumb: '../static/tenduAdd_F.jpg',
      },
      { id: 'slide4',
        url: '../static/tenduAdd_G.jpg',
        big: '../static/tenduAdd_G.jpg',
        thumb: '../static/tenduAdd_G.jpg',
      },
    ],

    davPhotos: [
      { id: 'slide1',
        url: '../static/dav01.jpg',
      },
      { id: 'slide2',
        url: '../static/dav02.jpg',
      },
      { id: 'slide3',
        url: '../static/dav03.jpg',
      }
    ],

    sectorPhotos: [
      { id: 'slide1',
        url: '../static/mm01.jpg',
      },
      { id: 'slide2',
        url: '../static/mm02.jpg',
      },
      { id: 'slide3',
        url: '../static/mm03.jpg',
      },
      { id: 'slide4',
        url: '../static/mm04.jpg',
      },
      { id: 'slide5',
        url: '../static/mm05.jpg',
      }
    ],

    sectorBarOptions: {
      animations: {
        enabled: false
      },
      tooltip: {
        enabled: false,
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val
        },
        offsetY: -20,
        style: {
          fontSize: '11px',
          colors: ['#c51162']
        }
      },
      fill: {
        colors: ['#00838f', '#E91E63', '#9C27B0']
      },
      markers: {
        colors: ['#ffffff', '#ffffff', '#ffffff']
      },
      grid: {
        strokeDashArray: 0,
        row: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        },
        column: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        },
        xaxis: {
          lines: {
            show: false,
            offsetX: 0,
            offsetY: 0
          }
        },
        yaxis: {
          lines: {
            show: true,
            offsetX: 0,
            offsetY: 0
          }
        },
        padding: {
          top: 20,
          right: 0,
          bottom: 0,
          left: 0
        },
      },

      plotOptions: {
        horizontal: false,
        bar: {
          columnWidth: '80%',
          distributed: false,
          dataLabels: {
            position: 'top',
            style: {
              colors: ['#ccc'],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif'
            },
          }
        }
      },
      yaxis: {
        max: 10,
        min: 1,
        showDuplicates: false,
        trim: true,
        tickAmount: 3,
        forceNiceScale: true,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val
          },
        },
      },
      chart: {
        animations: {
          enabled: false,
        },
        foreColor: '#373d3f',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        labels: {
          offsetY: -5,
          style: {
            // colors: ['#ccc', '#ccc' ],
          }
        },
        axisTicks: {
          show: true,
        },
        tickAmount: 9,
        tickPlacement: 'between',
        floating: false,
        position: 'bottom',
        min:2,
        max: 11,
        categories: [],
      },
      responsive: [ {
      breakpoint: 1000,
      options: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          position: "bottom"
        }
      }
    }]
    },
    totalBarOptions: {
      tooltip: {
        enabled: false,
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val
        },
        offsetY: -20,
        style: {
          fontSize: '11px',
          colors: ['#c51162']
        }
      },
      fill: {
        colors: ['#00838f', '#E91E63', '#9C27B0']
      },
      markers: {
        colors: ['#ffffff', '#ffffff', '#ffffff']
      },
      grid: {
        row: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        },
        column: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        }
      },

      plotOptions: {
        horizontal: false,
        bar: {
          columnWidth: '80%',
          distributed: false,
          dataLabels: {
            position: 'top',
            style: {
              colors: ['#ccc'],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
            },
          }
        }
      },

      yaxis: {
        max: null,
        showDuplicates: false,
        trim: true,
        tickAmount: 3,
        forceNiceScale: true,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val
          },
        },

      },
      chart: {
        foreColor: '#373d3f',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        type: 'category',
        labels: {
          offsetY: -5,
           style: {
             // colors: ['#ccc', '#ccc' ],
           }
        },
        axisTicks: {
          show: true
        },
        tickAmount: 'dataPoints',
        tickPlacement: 'between',
        floating: false,
        position: 'bottom',
        min: 2,
        max: 11,
        categories: []
      },
      responsive: [ {
      breakpoint: 1000,
      options: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          position: "bottom"
        }
      }
    }]
    },
    onsightBarOptions: {
      tooltip: {
        enabled: false,
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val
        },
        offsetY: -20,
        style: {
          fontSize: '11px',
          colors: ['#c51162']
        }
      },
      fill: {
        colors: ['#00838f', '#E91E63', '#9C27B0']
      },
      markers: {
        colors: ['#ffffff', '#ffffff', '#ffffff']
      },
      grid: {
        row: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        },
        column: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        }
      },

      plotOptions: {
        horizontal: false,
        bar: {
          columnWidth: '80%',
          distributed: false,
          dataLabels: {
            position: 'top',
            style: {
              colors: ['#ccc'],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
            },
          }
        }
      },
      yaxis: {
        max: null,
        showDuplicates: false,
        trim: true,
        tickAmount: 3,
        forceNiceScale: true,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val
          },
        },
      },
      chart: {
        foreColor: '#373d3f',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        labels: {
          offsetY: -5,
          style: {
            // colors: ['#ccc', '#ccc' ],
          }
        },
        axisTicks: {
          show: true
        },
        tickAmount: 'dataPoints',
        tickPlacement: 'between',
        floating: false,
        position: 'bottom',
        min: 2,
        max: 11,
        categories: []
      },
      responsive: [ {
      breakpoint: 1000,
      options: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          position: "bottom"
        }
      }
    }]
    },
    flashBarOptions: {
      tooltip: {
        enabled: false
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val
        },
        offsetY: -20,
        style: {
          fontSize: '11px',
          colors: ['#c51162']
        }
      },
      fill: {
        colors: ['#00838f', '#E91E63', '#9C27B0']
      },
      markers: {
        colors: ['#ffffff', '#ffffff', '#ffffff']
      },
      grid: {
        row: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        },
        column: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        }
      },
      plotOptions: {
        horizontal: false,
        bar: {
          columnWidth: '80%',
          distributed: false,
          dataLabels: {
            position: 'top',
            style: {
              colors: ['#ccc'],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
            },
          }
        }
      },

      yaxis: {
        max: null,
        showDuplicates: false,
        trim: true,
        tickAmount: 3,
        forceNiceScale: true,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val
          },
        },
      },
      chart: {
        foreColor: '#373d3f',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        labels: {
          offsetY: -5,
          style: {
            // colors: ['#ccc', '#ccc' ],
          }
        },
        axisTicks: {
          show: true,
        },
        tickAmount: 'dataPoints',
        tickPlacement: 'between',
        floating: false,
        position: 'bottom',
        min: 2,
        max: 11,
        categories: []
      },
      responsive: [ {
      breakpoint: 1000,
      options: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          position: "bottom"
        }
      }
    }]
    },
    redpointBarOptions: {
      tooltip: {
        enabled: false,
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val
        },
        offsetY: -20,
        style: {
          fontSize: '11px',
          colors: ['#c51162']
        }
      },
      fill: {
        colors: ['#00838f', '#E91E63', '#9C27B0']
      },
      markers: {
        colors: ['#ffffff', '#ffffff', '#ffffff']
      },
      grid: {
        row: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        },
        column: {
          colors: ['#ffffff', '#ffffff', '#ffffff']
        }
      },

      plotOptions: {
        horizontal: false,
        bar: {
          columnWidth: '80%',
          distributed: false,
          dataLabels: {
            position: 'top',
            style: {
              colors: ['#ccc'],
              fontSize: '10px',
              fontFamily: 'Helvetica, Arial, sans-serif',
            },
          }
        }
      },
      yaxis: {
        max: null,
        showDuplicates: false,
        trim: true,
        tickAmount: 3,
        forceNiceScale: true,
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function (val) {
            return val
          },
        },
      },
      chart: {
        foreColor: '#373d3f',
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      xaxis: {
        labels: {
          offsetY: -5,
          style: {
            // colors: ['#ccc', '#ccc' ],
          }
        },
        axisTicks: {
          show: true,
        },
        tickAmount: 'dataPoints',
        tickPlacement: 'between',
        floating: false,
        position: 'bottom',
        min: 2,
        max: 11,
        categories: []
      },
      responsive: [ {
      breakpoint: 1000,
      options: {
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        legend: {
          position: "bottom"
        }
      }
    }]
    },
    colorButton:'#00838f',
  },

  getters: {
    isLocated (state) {
      return state.isLocated
    },

    xCoord (state) {
      return Math.round(state.gymMarker.lat)
    },

    yCoord (state) {
      return Math.round(state.gymMarker.lng)
    },

    gymMarker (state) {
      return state.gymMarker
    },

    filteredByAll(state) {
      if (state.isResetKiosk) {
        return state.listTemp
      } else {
        return getByGrade(getByNew(getByContest(getByToprope(getByVorstieg(getByRating(state.storeList, state.byRating), state.byVorstieg), state.byToprope), state.byContest), state.byNew), state.byGrade, state.colorButton)
      }
    },

    filteredByRating(state) {
      return getByRating(state.storeList, state.byRating)
    },

    filteredByKeyword() {
      return getByKeyword(state.storeList, state.byKeyword)
    },

    filteredByVorstieg(state) {
      return getByToprope(state.storeList, state.byVorstieg)
    },

    filteredByToprope(state) {
      return getByToprope(state.storeList, state.byToprope)
    },

    filteredByGrade(state) {
      return getByGrade(state.storeList, state.byGrade, state.colorButton)
    },

    filteredByNew(state) {
      return getByNew(state.storeList, state.byNew)
    },

    filteredByContest(state) {
      return getByContest(state.storeList, state.byContest)
    },
  },

  mutations: {
    forceKeyrender:state => {
     state.keyFilter += 1;
    },

    increment: state => {
      if(state.slideRange < 36) {
        state.slideRange++;
      }
    },

    userIncrement: state => {
      var inc = (state.active.gradeNo * 3) + 3
      if(state.slideRange < inc) {
        state.slideRange++;
      }
    },

    decrement: state => {
      if(state.slideRange > 3){
        state.slideRange--;
      }
    },

    userDecrement: state => {
      var dec = (state.active.gradeNo * 3) - 3
      if(state.slideRange > dec){
        state.slideRange--;
      }
    },

    changeButtonColor(state, payload) {
      state.colorButton = payload
    },

    changeByRating(state, payload) {
      state.byRating = payload
    },

    changeByVorstieg(state, payload) {
      state.byVorstieg = payload
    },

    changeByToprope(state, payload) {
      state.byToprope = payload
    },

    changeByGrade(state, payload) {
      state.byGrade = payload
    },

    changeByNew(state, payload) {
      state.byNew = payload
    },

    changeByContest(state, payload) {
      state.byContest = payload
    },

    changeResetKiosk(state, payload) {
      state.isResetKiosk = payload

    },

    changeUpdateKiosk(state, payload) {
      state.isResetKiosk = payload
    },

    changeMarkOpen(state, payload) {
      state.markOpen = payload
    },

    changeRateOpen(state, payload) {
      state.rateOpen = payload
    },

    changeIsMapbox(state, payload) {
      state.isMapbox = payload
    },

    changeMaxBar(state, payload) {
      state.sectorBarOptions = {...state.sectorBarOptions, ...{
        yaxis: {
          max: payload,
          axisTicks: {
            show: false,
          },
          tickAmount: 3,
          labels: {
            show: false,
          },
        }
      }}

    },

    changeTotalMaxBar(state, payload) {
      state.totalBarOptions = {...state.totalBarOptions, ...{
        dataLabels: {
          enabled: true
        },
        yaxis: {
          max: payload,
          axisTicks: {
            show: false,
          },
          tickAmount: 3,
          labels: {
            show: false,
          },
        }
      }}
    },

    changeOnsightMaxBar(state, payload) {
      state.onsightBarOptions = {...state.onsightBarOptions, ...{
        dataLabels: {
          enabled: true
        },
        yaxis: {
          max: payload,
          axisTicks: {
            show: false,
          },
          tickAmount: 3,
          labels: {
            show: false,
          },
        }
      }}
    },

    changeFlashMaxBar(state, payload) {
      state.flashBarOptions = {...state.flashBarOptions, ...{
        dataLabels: {
          enabled: true
        },
        yaxis: {
          max: payload,
          axisTicks: {
            show: false,
          },
          tickAmount: 3,
          labels: {
            show: false,
          },
        }
      }}
    },

    changeRedpointMaxBar(state, payload) {
      state.redpointBarOptions = {...state.redpointBarOptions, ...{
        dataLabels: {
          enabled: true
        },
        yaxis: {
          max: payload,
          axisTicks: {
            show: false,
          },
          tickAmount: 3,
          labels: {
            show: false,
          },
        }
      }}
    },

    changeUserPrivileges(state, payload) {
      state.userPrivileges = payload
    },

    changeIsSetter(state, payload) {
      state.isSetter = payload
    },

    changeIsManager(state, payload) {
      state.isManager = payload
    },

    changeTotalKPI(state, payload) {
      state.totalKPI = payload
    },
    changeOnsightKPI(state, payload) {
      state.onsightKPI = payload
    },
    changeFlashKPI(state, payload) {
      state.flashKPI = payload
    },
    changeRedpointKPI(state, payload) {
      state.redpointKPI = payload
    },

    changeTimePeriod(state, payload) {
      state.timePeriod = payload
    },

    changeCutOffDate(state, payload) {
      state.cutOffDate = payload
    },

    changeValidUser(state, payload) {
      state.validUser.hash = payload.hash
      state.validUser.userNick = payload.userNick
    },

    changeTab(state, payload) {
      state.climboTab = payload
    },

    changeProjectLoad(state, payload) {
      state.projectLoading = payload
    },

    changeStatsLoad(state, payload) {
      state.statsLoading = payload
    },

    changeTag(state, payload) {
      state.isTag = payload
    },

    changeLook (state,payload) {
      state.sectorQuery = payload
    },

    changeProjectTrash (state, payload) {
      state.projectTrash = payload
    },

    changeProfileEdit (state, payload) {
      state.profileEdit = payload
    },

    changeImagePreview (state, payload) {
      state.imagePreview = payload
    },

    UPDATE_NUMBER (state, payload) {
      state.isNumber = payload
    },

    changeBack (state, payload) {
      state.isBack = payload
    },

    changeFromMap (state, payload) {
      state.fromMap = payload
    },

    changeGymActive(state, row) {
      state.gymActive.color = row.color
      state.gymActive.routeName = row.routeName
      state.gymActive.isLead = row.isLead
      state.gymActive.isToprope = row.isToprope
      state.gymActive.routeSetter = row.routeSetter
      state.gymActive.remarks = row.remarks
      state.gymActive.dateCreated = row.dateCreated
      state.gymActive.wallArea = row.wallArea
      state.gymActive.attributes = row.attributes
      state.gymActive.unpublishable = row.unpublishable
      state.gymActive.isPublished = row.isPublished
      state.gymActive.sortWeight = row.sortWeight
      state.gymActive.editUrl = row.editUrl
      if (!row.gradeFrench) {
        state.gymActive.gradeFrench = ''
      } else {
        state.gymActive.gradeFrench = row.gradeFrench
      }
      state.gymActive.internalNote = row.internalNote
      state.gymActive.routeRemovedBy = row.routeRemovedBy
      state.gymActive.links.updateRoute = row.links.updateRoute
    },

    changeGymAttributes(state, attributes) {
      state.gymActive.attributes = attributes
    },

    changeActiveName(state, payload) {
      state.isActiveName = payload
    },

    changeGymWalls(state, wallAreas) {
      state.gymWalls = wallAreas
    },

    changeSectorColors(state, payload) {
      state.sectorColors = payload
    },

    changeDefaultSector(state, payload) {
      state.defaultSector = payload
    },

    changeActiveOnly(state, payload) {
      state.activeOnly = payload
    },

    changeTotalGymRoutes(state, payload) {
      state.totalGymRoutes = payload
    },

    changeGymTitle(state, payload) {
      state.gymTitle = payload
    },

    changeFromGym(state, payload) {
      state.fromGymList = payload
    },

    changeGymListDetails(state, payload) {
      state.gymListDetails = payload
    },

    changePageLoading(state, payload) {
      state.pageLoading = payload
    },

    changeNumberSector(state, payload) {
      state.numberSector = payload
    },

    changeSectorGymId(state, payload) {
      state.sectorGymId = payload
    },

    changeRouteGymId(state, payload) {
      state.routeGymId = payload
    },

    changeUrlGym(state,payload) {
      state.urlGym = payload
    },

    changeGymLinks(state,payload) {
      state.qrPrintLink = payload.links.exportRouteStickers
      state.signLink = payload.links.exportRouteSigns
      state.excelLink = payload.links.exportXLSX
      state.importLink = payload.links.importXLSX
      state.updateSort = payload.links.updateSortWeights
    },

    changeSlideRange(state, slide) {
      state.slideRange = slide
    },

    changeLogDate(state, date) {
      state.logDate = new Date(date)
    },

    changeProjects(state, payload) {
      state.projectRoutes = payload
    },

    changeProjectsId(state, payload) {
      state.projectsId = payload
    },

    changePreviewSector(state, preview) {
      state.previewSector = preview
    },

    changeSidebar(state,payload) {
      state.isSidebar = payload
    },

    changeQRcode(state,payload) {
      state.isQRcode = payload
    },

    changeNavigate(state, isNavigate) {
      state.isNavigate = isNavigate
    },

    changeTenduLoading(state, isNavigate) {
      state.tenduLoading = isNavigate
    },

    changeStoreList(state, payload) {
      state.storeList = payload
    },

    changeActive(state, payload) {
      Object.assign(state.active, payload)
      state.popCount = payload.rating.count
      state.popValue = payload.rating.value
    },

    changeDetails(state, payload) {
      state.sectorDetails = payload
    },

    changeGymClimbo(state, item) {
      state.gymClimbo = item
    },

    changeMarker(state, marker) {
      if (state.active.overview.x) {
        var nx = state.active.overview.x
        var ny = state.active.overview.y
        state.marker = L.latLng(nx, ny)
      } else {
        state.marker = L.latLng(110 ,180)
      }
    },

    changeDraggable(state, payload) {
      state.draggable = payload
    },

    changeGymMarker(state, marker) {
      state.gymMarker = marker
    },

    changeIsLocated(state, payload) {
      state.isLocated = payload
    },

    changeXcoord(state, payload) {
      state.xCoord = payload
    },

    changeYcoord(state, payload) {
      state.yCoord = payload
    },

    loadRating(state, payload) {
      state.isRating = true
      state.userRating = payload.rating
      state.publicComment = payload.comment
      state.slideRange = (payload.gradeNo * 3).toFixed(0)
      state.userAttributes = payload.attributes
    },

    showLoading (state, payload) {
      state.isListLoading = payload
    },

    setSector(state, sectorId) {
      state.sectorDetails.id = sectorId
    },

    setNewLink(state, newLink) {
      state.newRouteLink = newLink
    },

    setLink(state, sectorLink) {
      state.sectorLink = sectorLink
    },

    setNextLink(state, nextLink) {
      state.nextLink = nextLink
    },

    setPrevLink(state, nextLink) {
      state.prevLink = prevLink
    },

    setMinor(state, defaultMinor) {
      state.defaultMinor = Math.round(defaultMinor * 3)
    },

    setMajor(state, defaultMajor) {
      state.defaultMajor = Math.round(defaultMajor * 3)
    }
  },

  actions: {
    getSector ({ commit, state }, payload) {
      Vue.http.get(payload)
      .then((response) => {
        state.sectorDetails.overviewImageUrl = response.data.overviewImageUrl
        state.sectorDetails.slideImages = response.data.slideImages
        commit('changeDetails', response.data)
        commit('setSector', response.data.id)

        var statsLink = response.data.links.sectorStats
        Vue.http.get(statsLink)
        .then((response) => {
          commit('setMinor', response.data.gradeRange.minGradeNo)
          commit('setMajor', response.data.gradeRange.maxGradeNo)
          state.sectorStats = response.data
        },
        (response) => {
          // error callback
        })
        //
        var statsLink = response.data.links.sectorStats
        store.dispatch('gettingSectorKPI', statsLink)
      },
      (response) => {
        // error callback
      })
    },

    gettingSectorKPI ({ commit, state }, payload) {
      Vue.http.get(payload)
      .then((response) => {
        commit('setMinor', response.data.gradeRange.minGradeNo)
        commit('setMajor', response.data.gradeRange.maxGradeNo)

        state.sectorStats = response.data
        state.sectorStats.countByDifficulty = response.data.countByDifficulty

        var maxCalc = Math.max(...Object.values(state.sectorStats.countByDifficulty)) + 9
        var arrayX = Object.keys(state.sectorStats.countByDifficulty).map(Number)
        state.sectorBarOptions = {...state.sectorBarOptions, ...{
          animations: {
            enabled: false,
          },
          yaxis: {
            max: maxCalc,
            axisTicks: {
              show: false,
            },
            tickAmount: 3,
            labels: {
              show: false,
            },
          },
          xaxis: {
            labels: {
              offsetY: -5,
            },
            categories: arrayX
          }
        }}
        // console.log(arrayX)
        const sectorData = Object.values(state.sectorStats.countByDifficulty)
        state.sectorSeries = [{
          data: sectorData
        }]
      },
      (response) => {
        // error callback
      })
    },

    gettingUserKPI ({ commit, state }, payload) {
      state.pageLoading = true
      Vue.http.get(payload, { params: { timeframe: state.timePeriod }})
        .then((response) => {
          commit('changeCutOffDate', response.data.cutOffDate)
          commit('changeTotalKPI',response.data.kpi['total'])

          var totalX = Object.keys(state.totalKPI.countByDifficulty)
          if (totalX.length > 0) {
            state.totalBarOptions = {...state.totalBarOptions, ...{
              xaxis: {
                categories: totalX
              }
            }}
          } else {
            state.totalBarOptions = {...state.totalBarOptions, ...{
              dataLabels: {
                enabled: false
              },
              xaxis: {
                categories: state.globalCategories
              }
            }}
          }

          var totalY = Math.max(...Object.values(state.totalKPI.countByDifficulty)) + 1
          var totalData = Object.values(state.totalKPI.countByDifficulty)
          // console.log('totalData', totalData)
          if (totalData.length > 0) {
            state.totalSeries = [{
              data: totalData
            }]
            commit('changeTotalMaxBar', totalY)

          } else {
            state.totalSeries = [{
              data: state.globalDataSeries
            }]
          }

          // ONSIGHT KPI RESPONSE
          commit('changeOnsightKPI',response.data.kpi['Onsight flash'])
          var onsightX = Object.keys(state.onsightKPI.countByDifficulty)
          if (onsightX.length > 0) {
            state.onsightBarOptions = {...state.onsightBarOptions, ...{
              xaxis: {
                categories: onsightX
              }
            }}
          } else {
            state.onsightBarOptions = {...state.onsightBarOptions, ...{
              dataLabels: {
                enabled: false
              },
              xaxis: {
                categories: state.globalCategories
              }
            }}
          }
          var onsightY = Math.max(...Object.values(state.onsightKPI.countByDifficulty)) + 1
          var onsightData = Object.values(state.onsightKPI.countByDifficulty)

          if (onsightData.length > 0) {
            state.onsightSeries = [{
              data: onsightData
             }]
             commit('changeOnsightMaxBar', onsightY)

          } else {
            state.onsightSeries = [{
              data: state.globalDataSeries
             }]
          }

          // FLASH KPI RESPONSE
          commit('changeFlashKPI', response.data.kpi['Beta flash'])

          var flashX = Object.keys(state.flashKPI.countByDifficulty)
          if (flashX.length > 0) {
            state.flashBarOptions = {...state.flashBarOptions, ...{
              xaxis: {
                categories: flashX
              }
            }}
          } else {
            state.flashBarOptions = {...state.flashBarOptions, ...{
              dataLabels: {
                enabled: false
              },
              xaxis: {
                categories: state.globalCategories
              }
            }}
          }

          var flashY = Math.max(...Object.values(state.flashKPI.countByDifficulty)) + 1
          var flashData = Object.values(state.flashKPI.countByDifficulty)

          if (flashData.length > 0) {
            state.flashSeries = [{
              data: flashData
            }]
            commit('changeFlashMaxBar', flashY)

          } else {
            state.flashSeries = [{
              data: state.globalDataSeries
            }]
          }

          // REDPOINT KPI RESPONSE
          commit('changeRedpointKPI', response.data.kpi['Redpoint'])
          var redpointX = Object.keys(state.redpointKPI.countByDifficulty)

          if (redpointX.length > 0) {
            state.redpointBarOptions = {...state.redpointBarOptions, ...{
              xaxis: {
                categories: redpointX
              }
            }}
          } else {
            state.redpointBarOptions = {...state.redpointBarOptions, ...{
              dataLabels: {
                enabled: false
              },
              xaxis: {
                categories: state.globalCategories
              }
            }}
          }

          var redpointY = Math.max(...Object.values(state.redpointKPI.countByDifficulty)) + 1
          var redpointData = Object.values(state.redpointKPI.countByDifficulty)
          if (redpointData.length > 0) {
            state.redpointSeries = [{
              data: redpointData
            }]
            commit('changeRedpointMaxBar', redpointY)
          } else {
            state.redpointSeries = [{
              data: state.globalDataSeries
            }]
          }

          state.pageLoading = false

        },
        (response) => {
           console.log('not success')
        })
    },

    getList ({ commit, state }, payload) {
      state.pageLoading = true
      Vue.http.get(payload + '/?limit='+ state.noOfLoading +'&start=0')
        .then(function (response) {
          state.nextLink = response.data.links.next
          state.prevLink = response.data.links.prev
          state.pagLimit = response.data.pagination.limit

          state.storeList = Object.freeze(response.data.routeDetailsShort)
          state.listTemp = Object.freeze(response.data.routeDetailsShort)
          state.changeSector = state.sectorDetails.name
          state.filterSet = 'C'
          // console.log('changeSector name', state.changeSector)
          // commit('changePageLoading', true)
          state.pageLoading = false
        },
        (response) => {
          console.log('not success')
        })
    },

    getRatingStatement ({ commit, state }, payload) {
      Vue.http.get(payload)
      .then(function (response) {
        state.isRating = true
        state.userRating = response.data.rating
        state.publicComment = response.data.comment
        state.slideRange = (response.data.gradeNo * 3).toFixed(0)
        state.userAttributes = response.data.attributes
      },
      (response) => {
        // error callback
        state.isRating = false
        state.publicComment = ''
        state.userRating = 0
        state.userAttributes = []
        state.slideRange = (state.active.gradeNo * 3).toFixed(0)
      })
    },

    getRouteStatements ({ commit, state }, payload) {
      Vue.http.get(payload)
      .then(function (response) {
        state.routeStatements = response.data.ratingStatements.map(e => e).sort((a, b) => (b.date) - (a.date))
        state.attributes = state.active.attributes.toString()
      }, response => {
        console.log('error')
      })
    },

    refreshGymList ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
          // console.log('refresh after add new route link', payload)
          Vue.http.get(payload)
          .then(response => {
            // console.log('and the response', response.data)
            commit('setNewLink', response.data.links.newRoute)
            state.gymListDetails = response.data.routes
            state.qrPrintLink = response.data.links.exportRouteStickers
            state.signLink = response.data.links.exportRouteSigns
            state.excelLink = response.data.links.exportXLSX
            state.importLink = response.data.links.importXLSX
            state.updateSort = response.data.links.updateSortWeights
            state.totalGymRoutes = response.data.noOfRoutes

            resolve(response);
            state.pageLoading = false
          }, error => {
            console.log('not success')
            reject(error);
          })
      })
    },

    loadGymEdit ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
          Vue.http.get(payload)
          .then(response => {
            state.gymListDetails = response.data.routes
            state.qrPrintLink = response.data.links.exportRouteStickers
            state.signLink = response.data.links.exportRouteSigns
            state.excelLink = response.data.links.exportXLSX
            state.importLink = response.data.links.importXLSX
            state.updateSort = response.data.links.updateSortWeights

            for(var i = 0; i < state.gymListDetails.length; i += 1) {
              if(state.gymListDetails[i].id === Number(state.routeGymId)) {
                commit('changeGymActive', state.gymListDetails[i])
                commit('changeGymClimbo', state.gymListDetails[i])

                var slide = (state.gymClimbo.gradeNo * 3).toFixed(0)
                commit('changeSlideRange', slide)

                var date = new Date(state.gymClimbo.dateCreated)
                commit('changeLogDate', date)
                // console.log('logDate from store', this.logDate)
                var attributes = state.gymClimbo.attributes
                commit('changeGymAttributes', attributes)

                if (!state.gymClimbo.overview.x) {
                  commit('changeIsLocated', false)
                  // console.log('No location set')
                } else {
                  state.draggable = false
                  commit('changeIsLocated', true)

                  var nx = state.gymClimbo.overview.x
                  var ny = state.gymClimbo.overview.y

                  state.gymMarker = L.latLng(nx, ny)
                }
                state.fromGymList = true
              }
            }
            return -1
            resolve(response)

          }, error => {
            alert('Route bearbeiten. Du must angemeldet sein')
            // http failed, let the calling function know that action did not work out
            console.log('slow connection')
            reject(error);
          })
      })
    },

    refreshList ({ commit, state }, payload) {
      commit('changePageLoading', true)
      commit('showLoading', true)
      Vue.http.get(payload)
      .then(function (response) {
        state.storeList = Object.freeze(response.data.routeDetailsShort)
        commit('showLoading', false)
        commit('changePageLoading', false)
      })
    },

    getPaging ({ commit, state }, payload) {
      state.isListLoading = true
        Vue.http.get(payload)
        .then(response => {
          state.nextLink = response.data.links.next
          state.prevLink = response.data.links.prev
          state.storeList = [...state.storeList, ...response.data.routeDetailsShort]
          state.isListLoading = false
        },(response) => {
          console.log('not success')
        })
    },

    getGymPaging ({ commit, state }, payload) {
      state.pageLoading = true
        // var gymLink = payload + '/?active_only=' + state.activeOnly + '&limit=' + state.noOfLoading + '&start=' + state.gymListDetails.length
        var gymLink = payload + '/?limit='+ state.noOfLoading +'&start=' + state.gymListDetails.length + '&active_only=' + state.activeOnly

        Vue.http.get(gymLink)
        .then(response => {
          state.gymListDetails = [...state.gymListDetails, ...response.data.routes]
          state.pageLoading = false
        },(response) => {
          console.log('not success')
          state.pageLoading = false
          alert('There is problem with your request, please try later')
        })
    },

    removeProject ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        Vue.http.post(state.active.links.updateProjectState, payload)
          .then(response => {
            // http success, call the mutator and change something in state
            resolve(response);
        }, error => {
            // http failed, let the calling function know that action did not work out
            reject(error);
        })
      })
    },

    addProject ({ commit, state }, payload) {
      Vue.http.post(state.active.links.updateProjectState, payload)
        .then((response) => {
          if ((response.data.action === 'add') && response.data.done) {
            commit('changeTag', true)
          } else {
            commit('changeTag', false)
          }
        },
        (response) => {
          // console.log('not success')
      })
    }
  }
})
